import axiosClient from './axiosClient';
interface RefreshTokenResponse {
    access_token: string;
}

export const refreshTokenApi = (data: { refresh_token: string }): Promise<RefreshTokenResponse> => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/refresh-token`;
    return axiosClient.post(url, data);
};
